import { render } from "./WelcomeDismissable.vue?vue&type=template&id=4abc623b"
import script from "./WelcomeDismissable.vue?vue&type=script&lang=js"
export * from "./WelcomeDismissable.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__